// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6882893c] .dot {\n  width: 30px !important;\n  height: 30px !important;\n}\n.text-normal[data-v-6882893c] {\n  color: black;\n  font-size: 14px;\n  font-family: Lato;\n  font-weight: 400;\n  line-height: 16.8px;\n  word-wrap: break-word;\n}\n.text-bold[data-v-6882893c] {\n  color: black;\n  font-size: 14px;\n  font-family: Lato;\n  font-weight: 700;\n  line-height: 16.8px;\n  word-wrap: break-word;\n}\nli[data-v-6882893c] {\n  line-height: 30px;\n}", ""]);
// Exports
module.exports = exports;
